import React, {useState,useEffect} from 'react'
import b from './BurlesonCoreValues.json'
import FeedbackItem from './FeedbackItem';

export default function Feedback() {
    const [feedbackData,setFeedbackData] = useState([]);

    useEffect(()=>{
        setFeedbackData(b.map((item)=>{
            if(item.isActive){
                return <FeedbackItem text={item.c_val} date={item.c_date} key={item.c_id}></FeedbackItem>
            }
    }))
    },[])

    return (
        <div>
            <div className='text-start feedback'>
                {feedbackData}
            </div>
        </div>
    )
}
